import { useState, useRef, useEffect, useCallback } from "react";
import SvgMapper from "../features/common/SvgMapper";
import "../features/common/Style.css";
import "./Style.css";

const CustomDropdown = ({ 
  value, 
  options, 
  onChange, 
  className = "",
  onLoadMore,
  hasMore = false,
  loading = false,
  maxHeight = "300px"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleScroll = useCallback(() => {
    const menu = menuRef.current;
    if (!menu || !onLoadMore || !hasMore || loading) return;

    const { scrollTop, scrollHeight, clientHeight } = menu;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      onLoadMore();
    }
  }, [onLoadMore, hasMore, loading]);

  useEffect(() => {
    const menu = menuRef.current;
    if (isOpen && menu && onLoadMore) {
      menu.addEventListener("scroll", handleScroll);
      return () => {
        menu.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isOpen, handleScroll, onLoadMore]);

  const handleSelect = (optionValue) => {
    onChange({
      target: { value: optionValue },
    });
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  return (
    <div ref={dropdownRef} className={`custom-dropdown-container ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="custom-dropdown-button"
      >
        <span>{selectedOption.label}</span>
        <span
          className={`custom-dropdown-chevron ${
            isOpen ? "custom-dropdown-chevron-open" : ""
          }`}
        >
          {SvgMapper.dropdown("w-4 h-4 text-gray-500")}
        </span>
      </button>
      {isOpen && (
        <div 
          ref={menuRef}
          className={`custom-dropdown-menu ${onLoadMore ? 'custom-scrollbar' : ''}`}
          style={{ 
            maxHeight: onLoadMore ? maxHeight : undefined,
            overflowY: onLoadMore ? "auto" : undefined
          }}
        >
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => handleSelect(option.value)}
              className={`custom-dropdown-option ${
                value === option.value ? "custom-dropdown-option-selected" : ""
              }`}
            >
              {value === option.value && (
                <span className="custom-dropdown-checkmark">✓</span>
              )}
              <span>{option.label}</span>
            </button>
          ))}
          {loading && hasMore && (
            <div className="custom-dropdown-loading">
              <p style={{ padding: "0.5rem", textAlign: "center", color: "#9ca3af", fontSize: "0.875rem" }}>
                Loading more...
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;

